import { Box, pxToRem, themeGet } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const StyledBox = styled(Box) `
  height: 100%;
  justify-content: space-between;
  flex-direction: column;
  border: ${pxToRem(1)} solid ${themeGet('colors.border.100')};
  border-radius: ${themeGet('borderRadius.md')};
  box-shadow: ${themeGet('dropShadow.100')};
  padding: ${themeGet('spacing.lg')};
  gap: ${themeGet('spacing.md')};
`;
